import React from "react";
import { DateField } from "../input/DateField";
import { NepaliDateField } from "../input/NepaliDateField";
import { convertADToBS } from "../../utils/date.utils";
import { RadioButton } from "../Button/RadioButton";
import { DISPLAY, POSITION, SPACING } from "../../Constants/Enums/styles.enum";
interface IProps {
  date: Date | string | null;
  setDate: (date: string) => unknown;
  title: string;
}
enum DateType {
  AD = "AD",
  BS = "BS",
}

export const AdBsCalendar = ({ setDate, date, title }: IProps) => {
  const [selectedDateType, setSelectedDateType] = React.useState<DateType>(
    DateType.BS
  );

  const isBSSelected = selectedDateType === DateType.BS;
  const isADSelected = selectedDateType === DateType.AD;

  const BSDate = convertADToBS(date as string);

  const setBSDate = ({ adDate }: { adDate: string }) => {
    setDate(adDate);
  };

  const renderHeader = () => {
    return (
      <div
        style={{
          display: DISPLAY.FLEX,
          gap: SPACING.S8,
        }}
      >
        <RadioButton
          isChecked={isBSSelected}
          label={"B.S"}
          onChange={() => setSelectedDateType(DateType.BS)}
          name={"dateType"}
          value={DateType.BS}
        />
        <RadioButton
          isChecked={isADSelected}
          label={"A.D"}
          onChange={() => setSelectedDateType(DateType.AD)}
          name={"dateType"}
          value={DateType.AD}
        />
      </div>
    );
  };

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      {selectedDateType === DateType.AD ? (
        <DateField
          setDate={setDate}
          date={date}
          label={`${title} (A.D)`}
          headerComponent={renderHeader()}
        />
      ) : (
        <NepaliDateField
          label={`${title} (B.S)`}
          date={BSDate}
          setDate={setBSDate}
          headerComponent={renderHeader()}
        />
      )}
    </div>
  );
};
